module.exports = __webpack_public_path__ + "static/img/tiktok.ed9c676.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiktok.png
// module id = GkVo
// module chunks = 2